module.exports = __webpack_public_path__ + "img/06.2da94e6e.jpg";